import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BookingWindow } from '../../../triage/triage.component';

@Component({
  selector: 'triage-question-booking-windows',
  templateUrl: './triage-question-booking-windows.component.html',
  styleUrls: ['./triage-question-booking-windows.component.css', './../../../triage/triage.component.css']
})
export class TriageQuestionBookingWindowsComponent implements OnInit {
  
  @Input() bookingWindows: Array<BookingWindow>;
  @Input() clientID: number;
  @Input() outOfHoursEnabled: boolean;
  
  @Output() initBookingOptionEvent = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
  }
  
  public initBookingOption(window: number): void {
    this.initBookingOptionEvent.emit(window);
  }

}
